/**
 * E-mails que a plataforma enviou (resposta do atendente, regra de automação).
 *
 * O backend expõe `message.email` com direção e destinatários. Solicitações de
 * e-commerce costumam ficar sem responsável, então a mensagem é gravada sem
 * usuário: sem esta checagem a timeline atribui o e-mail ao cliente.
 */

/** @returns {{direction: string, to: ?string, cc: string[], from: ?string, subject: ?string,
 *   attachments: Array<{name: string, url: ?string, type: ?string, size: number}>,
 *   automation: ?{ruleId: number, ruleName: ?string}}|null} */
export const getOutboundEmailDetails = (message) => {
  const email = message?.email;
  if (email && email.direction === "outbound") {
    return {
      direction: "outbound",
      to: email.to || null,
      cc: Array.isArray(email.cc) ? email.cc.filter(Boolean) : [],
      from: email.from || null,
      subject: email.subject || null,
      attachments: Array.isArray(email.attachments)
        ? email.attachments.filter((file) => file && (file.name || file.url))
        : [],
      automation: email.automation?.ruleId
        ? {
            ruleId: email.automation.ruleId,
            ruleName: email.automation.ruleName || null,
          }
        : null,
    };
  }

  // Endpoints que ainda não devolvem `email` (ex.: detalhes da conversa).
  if (String(message?.senderType || "").toLowerCase() === "automation") {
    return {
      direction: "outbound",
      to: null,
      cc: [],
      from: null,
      subject: null,
      automation: { ruleId: null, ruleName: message?.senderName || null },
      attachments: [],
    };
  }

  return null;
};

export const isOutboundEmailMessage = (message) =>
  Boolean(getOutboundEmailDetails(message));

const SUBJECT_PREFIX = /^\s*assunto:\s*/i;

/**
 * O backend grava `mensagem` como "Assunto: <assunto>\n\n<corpo>". O card mostra
 * o assunto no cabeçalho, então o corpo é exibido sem repeti-lo.
 */
export const splitStoredEmail = (raw) => {
  const text = String(raw || "");
  const [firstLine, ...rest] = text.split("\n");
  if (SUBJECT_PREFIX.test(firstLine)) {
    return {
      subject: firstLine.replace(SUBJECT_PREFIX, "").trim(),
      body: rest.join("\n").trim(),
    };
  }
  return { subject: null, body: text };
};
